"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Feature_js_1 = __importDefault(require("ol/Feature.js"));
var Point_js_1 = __importDefault(require("ol/geom/Point.js"));
var layer_js_1 = require("ol/layer.js");
var Vector_js_1 = __importDefault(require("ol/source/Vector.js"));
var style_js_1 = require("ol/style.js");
var HarbourLayer = /** @class */ (function () {
    function HarbourLayer() {
        var self = this;
        var icon = new style_js_1.Icon({
            src: '/assets/icons/anchor.svg'
        });
        var style = new style_js_1.Style({
            image: icon,
        });
        var styles = function (feature, resolution) {
            var scale = resolution < 1000 ? _.min([0.8, (0.5 + (resolution < 100 ? 10 / resolution : 100 / resolution))]) : 0.5;
            icon.setScale(scale);
            return style;
        };
        this.layer = new layer_js_1.Vector({
            source: new Vector_js_1.default({
                features: []
            }),
            style: styles
        });
        this.layer.setZIndex(150);
    }
    HarbourLayer.prototype.addFeature = function () {
        var feature = new Feature_js_1.default({
            geometry: new Point_js_1.default([0, 0])
        });
        this.layer.getSource().addFeature(feature);
        return feature;
    };
    HarbourLayer.prototype.get = function () {
        return this.layer;
    };
    HarbourLayer.prototype.getExtent = function () {
        return this.layer.getSource().getExtent();
    };
    HarbourLayer.prototype.setPosition = function (feature, position) {
        feature.getGeometry().setCoordinates(position);
    };
    return HarbourLayer;
}());
exports.default = HarbourLayer;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/trips/classes/harbour.js
// module id = 568
// module chunks = 0